<template>
  <v-container fluid style='background-color:white'>
    <v-layout row wrap fill-height justify-center>
      <v-flex xs12 sm12 md12 lg12>
        <v-card flat>
          <br />
          <v-layout justify-center >
            <v-card-title class='headlinestyle'><strong>อนุมัติรายการสั่งสินค้า</strong></v-card-title>
          </v-layout>
          <br />
        <v-layout row wrap justify-center align-end>
          <v-flex xs12 sm11 md11 lg11>
            <v-layout row wrap justify-start>
              <v-flex xs12 sm6 md3 lg3 px-5>
                <p style="color:#4C4C4C; font-size:90%;"><strong>รหัสร้านค้า</strong></p>
                <v-text-field v-model="username_search" outlined clearable dense v-on:input="orderfilterfunction()" color="pink lighten-3"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md3 lg3 px-5>
                <p style="color:#4C4C4C; font-size:90%;"><strong>ชื่อ-สกุล</strong></p>
                <v-text-field v-model="name_search" outlined clearable dense v-on:input="orderfilterfunction()" color="pink lighten-3"></v-text-field >
              </v-flex>
                <v-flex xs12 sm6 md3 lg3 px-5>
                <p style="color:#4C4C4C; font-size:90%;"><strong>วันที่สั่งซื้อ</strong></p>
                <VueCtkDateTimePicker color="#F06292" :no-value-to-custom-elem="true" v-model="dateorderpicker" only-date range v-on:input="daterangefunction(dateorderpicker, 'order')">
                  <v-text-field v-model="dateorderview" outlined clearable dense color="pink lighten-3" readonly v-on:input="orderfilterfunction()"></v-text-field>
                </VueCtkDateTimePicker>
              </v-flex>
              <v-flex xs12 sm6 md3 lg3 px-5 v-for="(searchitem, i) in searchitems" :key="i">
                   <p style="color:#4C4C4C; font-size:90%;"><strong>{{searchitem.text}}</strong></p>
                    <v-combobox
                      v-model="searchitem.model"
                      :items="searchitem.items"
                      :item-text="searchitem.itemtext"
                      :item-value="searchitem.itemtext"
                      :return-object="false"
                      hide-selected
                      outlined
                      clearable
                      dense
                      multiple
                      persistent-hint
                      small-chips
                      v-on:input="orderfilterfunction()"
                      color="pink lighten-3"
                    ></v-combobox>
                </v-flex>
                <v-flex xs12 sm12 md12 lg12 px-3>
                  <v-layout align-end justify-end>
                    <div class="px-2">
                      <v-btn outlined color="indigo lighten-2" @click="openneworder()">
                        <v-icon>mdi-plus</v-icon>&nbsp;เพิ่มรายการ
                      </v-btn>
                    </div>
                  </v-layout>
                </v-flex>
              </v-layout>

          <br />
          <v-data-table
            :headers="headers"
            :items="orderdata_view"
            :items-per-page="10"
            class="elevation-3"
            :loading='loading'
            :footer-props="{
              itemsPerPageOptions: [5, 10, 20, 50, 100]
            }"
          >
          <template v-slot:body="{ items }">
                <tbody>
                  <tr
                    v-for="item in items"
                    :key="item._id"
                    style="cursor: pointer;"
                    align='center'
                  >
                  <td @click="openorderdetail(item._id)">{{ item.order_no }}</td>
                  <td @click="openorderdetail(item._id)">{{ item.username }}</td>
                  <td @click="openorderdetail(item._id)">{{ item.adminref_name }}</td>
                  <td @click="openorderdetail(item._id)">{{ item.name }}</td>
                  <td @click="openorderdetail(item._id)">{{ item.order_date_th }}</td>
                  <td @click="openorderdetail(item._id)">{{ item.tel }}</td>
                  <td @click="openorderdetail(item._id)">
                    <v-chip
                      :color="getColor(item.order_status)"
                      text-color="white"
                    >{{ item.order_status_th }}
                    </v-chip>
                  </td>
                  <td @click="openorderdetail(item._id)">{{ item.payment_status_th }}</td>
                  </tr>
                </tbody>
          </template>
          </v-data-table>
          </v-flex>
        </v-layout>
        <br />
        <br />
        </v-card>
      </v-flex>
      <Orderdetailmodal :parentgetdata="getdata" />
    </v-layout>
  </v-container>
</template>

<script>
import Orderdetailmodal from '@/components/Orderdetailmodal'
import axios from 'axios'
import { sync } from 'vuex-pathify'
import moment from 'moment'
moment.locale('th')
export default {
  components: {
    Orderdetailmodal
  },
  data: () => ({
    loading: false,
    headers: [
      { text: 'เลขที่เอกสาร', align: 'center', sortable: false, value: 'order_no' },
      { text: 'รหัสร้านค้า', align: 'center', sortable: false, value: 'username' },
      { text: 'เจ้าหน้าที่ผู้ดูแล', align: 'center', sortable: false, value: 'adminref_name' },
      { text: 'ชื่อ-สกุล', align: 'center', sortable: false, value: 'name' },
      { text: 'วันที่สั่ง', align: 'center', sortable: false, value: 'order_date_th' },
      { text: 'เบอร์โทร', align: 'center', sortable: false, value: 'tel' },
      { text: 'สถานะ', align: 'center', sortable: false, value: 'order_status' },
      { text: 'การชำระเงิน', align: 'center', sortable: false, value: 'payment_status' }
    ],
    orderdatas: [],
    orderdata_view: [],
    csvheader: ['วันที่เอกสาร', 'เลขที่เอกสาร', 'วันที่ใบกำกับภาษี', 'เลขที่ใบกำกับภาษี', 'รหัสลูกหนี้/เจ้าหนี้', 'รหัสซื้อขาย', 'จำนวนสินค้า', 'จำนวนแถม', 'ราคาต่อหน่วย', 'ส่วนลดต่อรายการ', 'ตน.เก็บ', 'ตน.เก็บโอนย้าย', 'ส่วนลดท้ายบิล', 'หมายเหตุท้ายบิล'],
    name_search: '',
    username_search: '',
    searchitems: [
      { text: 'เจ้าหน้าที่ผู้ดูแล', items: [], itemtext: 'adminref_name', model: [] }
    ],
    dateorderpicker: '',
    dateorderview: ''
  }),
  created () {
    if (this.$cookies.get('token') !== '') {
      if (this.$cookies.get('status') === 'super admin' || this.$cookies.get('status') === 'admin') {
        this.getdata()
      } else {
        this.$router.push('/')
      }
    } else {
      this.$router.push('/')
    }
  },

  methods: {
    getColor (status) {
      if (status === '00') return 'info'
      else if (status === '01') return 'success'
      else if (status === '02') return '#DD4B39'
    },
    async getdata () {
      try {
        this.loading = true
        let { data } = await axios.post(`${process.env.VUE_APP_API}/order/get/all`, {
          orderstatus: ['00'],
          paymentstatus: ['0', '1', '4']
        }, {
          headers: {
            Authorization: this.$cookies.get('token')
          }
        })
        this.orderdatas = data.orderdata.filter(pd => pd.order_status === '00').map((pd, index) => {
          return {
            ...pd,
            order_date_th: moment(pd.order_date).format('ll'),
            delivery_date_th: pd.delivery_date ? moment(pd.delivery_date).format('ll') : ''
          }
        })
        this.orderdata_view = this.orderdatas
        for (const searchitem of this.searchitems) {
          searchitem.items = searchitem.items.length === 0 ? this.orderdatas : searchitem.items
        }
        this.loading = false
        this.orderfilterfunction()
      } catch (error) {
        this.loading = false
      }
    },
    openorderdetail (id) {
      this.orderdetailmodal = true
      this.currentorderid = id || ''
      this.orderdetailmode = 2
    },
    orderfilterfunction () {
      this.orderdata_view = this.orderdatas.filter(order => {
        let condition = [
          this.name_search ? (order.name.toLowerCase()).includes((this.name_search).toLowerCase()) : true,
          this.username_search ? (order.username.toLowerCase()).includes((this.username_search).toLowerCase()) : true,
          this.searchitems[0].model.includes(order.adminref_name) || !this.searchitems[0].model.length,
          this.dateorderview ? order.order_date.split('T')[0] >= this.dateorderview.split(' ~ ')[0] && order.order_date.split('T')[0] <= this.dateorderview.split(' ~ ')[1] : true
        ]
        return condition.every(con => con)
      })
    },
    openneworder () {
      this.currentorderproduct = ''
      this.$router.push('/orderdetail')
    },
    daterangefunction (datepicker, mode) {
      if (mode === 'order') {
        this.dateorderview = `${datepicker.start.split(' ')[0]} ~ ${datepicker.end ? datepicker.end.split(' ')[0] : datepicker.start.split(' ')[0]}`
      }
      this.orderfilterfunction()
    }
  },
  computed: {
    orderdetailmodal: sync('orderdetailmodal'),
    currentorderid: sync('currentorderid'),
    orderdetailmode: sync('orderdetailmode'),
    currentorderproduct: sync('currentorderproduct')
  }
}
</script>

<style scoped >
.container {
  margin: 5px;
}
.container .con {
  margin: 0px;
}
.headlinestyle {
  font-family: 'Kanit';
  font-style: normal;
  font-weight: normal;
  font-size: 30px;
  line-height: 54px;
  color: #000000;
}
.v-data-table th {
  height: 60px !important;
}
td {
  max-width: 120px;
  overflow: hidden;
  text-overflow: clip;
  white-space: nowrap;
}
</style>

<style>
.date-time-picker * {
  font-family: 'Kanit' !important;
}
</style>
